<template>
  <b-dropdown
    right
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    :id="`dropdown-${this.currentDatabase.name}`"
    boundary="viewport"
    menu-class="navbar-dropdown"
    ref="dropdownComponent"
  >
    <template #button-content>
      <img class="dropdown-btn" src="../../assets/img/more-icon.svg" />
    </template>

    <b-dropdown-item
      v-for="option in actionOptions"
      class="item"
      :key="option.key"
      @click="$emit('onDropDownItemSelect', option.action)"
    >
      <span
        class="fas me-1"
        v-if="option.icon"
        :class="`fa-${option.icon}`"
        title="Teilen"
      ></span>
      <img
        v-if="option.imageName"
        class="available-image-icon me-0"
        :src="require('../../assets/img/' + option.imageName)"
      />
      {{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'dropdown-component',
  props: {
    currentDatabase: {
      type: Object,
    },
    actionOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    positionDropdown() {
      this.$nextTick(() => {
        const dropdownMenu = document.querySelector(
          `#dropdown-${this.currentDatabase.name} .dropdown-menu`
        );
        const listItem = document.querySelector(
          `#dropdown-${this.currentDatabase.name}`
        );
        if (dropdownMenu && listItem) {
          const outerScroll = document.querySelector('.nav-left');
          outerScroll.appendChild(dropdownMenu);
          const listItemRect = listItem.getBoundingClientRect();
          const dropdownMenuRect = dropdownMenu.getBoundingClientRect();
          dropdownMenu.addEventListener('mouseleave', () => {
            this.$refs['dropdownComponent'].hide();
          });
          dropdownMenu.style.position = 'fixed';
          dropdownMenu.style.top = `${listItemRect.bottom}px`;
          dropdownMenu.style.left = `${
            listItemRect.left - dropdownMenuRect.width
          }px`;
        }
      });
    },
  },
  created() {
    this.positionDropdown();
  },
};
</script>

<style scoped>
.action-menu {
  position: absolute;
  top: 30px;
  z-index: 1;
}
.action-menu ul.item-list.icon-view {
  height: 179px;
}

.action-menu ul.item-list {
  position: fixed;
  right: 40px;
  background: #fff;
  text-align: left;
  width: 150px;
  list-style: none;
  overflow: auto;
  border: solid 0.1px #f0f0f0;
  border-radius: 4px;
  padding: 0px;
}

.action-menu ul.item-list .item {
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  margin-left: 0px;
}
.action-menu ul.item-list .item:hover {
  background: #f0f0f0;
}
.nav-left .list-item .btn:first-child:active:focus-visible {
  box-shadow: none;
}
.available-image-icon {
  zoom: 1.6;
  vertical-align: middle !important;
}
</style>
